import React, { Component } from "react";
import "./MobileFilter.css";
import FilterMenu from "../../Components/Filters/FilterMenu/FilterMenu";
import { connect } from "react-redux";
import * as actions from "../../Store/Actions/index";
class MobileFilter extends Component {
  state = {
    index: 1,
    total: 10,
    page: "",
    gradeListOpen: false,
    subjectListOpen: false,
    boardListOpen: false,
    filterOption: [],
    classes: [],
    subjects: [],
    boards: [],
    mobileFilters: false,
  };

  toggleList(type) {
    if (type === "grade") {
      this.setState((prevState) => ({
        gradeListOpen: !prevState.gradeListOpen,
      }));
    }
    if (type === "subject") {
      this.setState((prevState) => ({
        subjectListOpen: !prevState.subjectListOpen,
      }));
    }
    if (type === "board") {
      this.setState((prevState) => ({
        boardListOpen: !prevState.boardListOpen,
      }));
    }
  }

  setFilterHandler = (e, id, type, index) => {
    var isChecked = e.target.value;
    if (isChecked) {
      if (type === "class") {
        this.state.classes.push(id);
      }
      if (type === "subjects") {
        this.state.subjects.push(id);
      }
      if (type === "boards") {
        this.state.boards.push(id);
      }
    } else {
      if (type === "class") {
        this.state.classes.splice(this.state.classes.indexOf(id), 1);
      }
      if (type === "subjects") {
        this.state.subjects.splice(this.state.subjects.indexOf(id), 1);
      }
      if (type === "boards") {
        this.state.boards.splice(this.state.boards.indexOf(id), 1);
      }
    }
  };

  applyFilter = () => {
    let payload = {
      classes: this.state.classes,
      subjects: this.state.subjects,
      boards: this.state.boards,
    };
    this.props.savePayload(payload)
    this.props.setFilter(payload);
  };

  render(h) {
    return (
      <div className="mobileFilterMenu">
        {this.props.currentState ? (
          <div className="md-modal  md-show md-effect-12">
            <div className="mobileSection">
              <h3>
                <div onClick={this.props.hide} data-icon="l" className="icon"></div>{" "}
                Filters
              </h3>
            </div>
            <div className="modal-scontent">
              <FilterMenu
                type="grade"
                state={this.state.gradeListOpen}
                toggleDropDown={(type) => this.toggleList(type)}
                callFilter={(event, id, type, index) =>
                  this.setFilterHandler(event, id, type, index)
                }
              />
              <FilterMenu
                type="subject"
                state={this.state.subjectListOpen}
                toggleDropDown={(type) => this.toggleList(type)}
                callFilter={(event, id, type, index) =>
                  this.setFilterHandler(event, id, type, index)
                }
              />
              <FilterMenu
                type="board"
                state={this.state.boardListOpen}
                toggleDropDown={(type) => this.toggleList(type)}
                callFilter={(event, id, type, index) =>
                  this.setFilterHandler(event, id, type, index)
                }
              />
            </div>

            <button
              className="btn btn-secondary md-close"
              onClick={this.applyFilter}
            >
              Apply
            </button>
          </div>
        ) : null}
        <div className="md-overlay"></div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedFilters: state.book.selectedFilter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFilter: (dataToBeFiltered) =>
      dispatch(actions.filterBooks(dataToBeFiltered)),
    savePayload: (payload) => dispatch(actions.savePayload(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileFilter);
